<template>
  <div class="main-slide slide-wrapper w-screen h-screen">
    <div class="flex flex-wrap">
      <div class="left-column w-2/5 h-screen pt-8 pb-2">
        <div class="left-column-inner flex flex-col h-full">
          <ZodiacPeople :key="zpKey" class="flex-1" />
          <Clock />
          <BirthdayThisMonth :key="dobKey" />
        </div>
      </div>
      <div class="right-column w-3/5 h-screen p-8 relative">
        <div class="right-column-inner flex flex-col h-full">
          <ZodiacRanking class="flex-1" />
          <DashedLine />
          <SalesFigure />
        </div>
        <!-- <VerticalBanner /> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import ZodiacPeople from './main-slide/left-column/ZodiacPeople'
import Clock from './main-slide/left-column/Clock'
import BirthdayThisMonth from './main-slide/left-column/BirthdayThisMonth'
import DashedLine from './main-slide/right-column/DashedLine'
import ZodiacRanking from './main-slide/right-column/ZodiacRanking'
import SalesFigure from './main-slide/right-column/SalesFigure'
import VerticalBanner from './main-slide/right-column/VerticalBanner'
import { mapGetters } from 'vuex'

export default {
  components: {
    Clock,
    ZodiacPeople,
    BirthdayThisMonth,
    DashedLine,
    ZodiacRanking,
    SalesFigure,
    VerticalBanner
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    ...mapGetters([
      'slideSetting',
      'zodiacPeopleConfig',
      'birthdayThisMonthConfig',
    ]),
    zpKey() {
      return JSON.stringify(this.zodiacPeopleConfig)
    },
    dobKey() {
      return JSON.stringify(this.birthdayThisMonthConfig)
    }
  }
}
</script>

<style scoped>

</style>